import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { faArrowLeft, faArrowRight } from '@/lib/fontAwesomePro/regular'
import { cn } from '@/lib/utils'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>

const ScrollHelpText: React.FC<Props> = ({ className, ...props }) => (
  <div
    className={cn(
      `text-dim sticky mt-2 flex items-center justify-end gap-2 text-center
      text-xs sm:hidden`,
      className,
    )}
    {...props}
  >
    <FontAwesomeIcon
      icon={faArrowLeft}
      style={{ position: 'relative', top: '1px' }}
    />
    Scroll to view more
    <FontAwesomeIcon
      icon={faArrowRight}
      style={{ position: 'relative', top: '1px' }}
    />
  </div>
)
export default ScrollHelpText
